const overlayClasses =
  "fixed inset-0 z-[10000000] flex flex-col items-center justify-center gap-4 " +
  "bg-white/80 backdrop-blur-sm";

const spinnerClasses =
  "animate-spin h-10 w-10 rounded-full border-4 border-current border-t-transparent text-primary";

const messageClasses = "text-content font-secondary text-sm font-medium";

const DemandStudioExitOverlay = ({ isVisible, message = "Finalizing your changes..." }) => {
  if (!isVisible) return null;
  return (
    <div className={overlayClasses} role="status" aria-live="polite">
      <i className={spinnerClasses} aria-hidden="true" />
      <span className={messageClasses}>{message}</span>
    </div>
  );
};

export default DemandStudioExitOverlay;
